import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef, useState } from 'react';
import { useInView } from 'framer-motion';
export var useStickyContainer = function useStickyContainer() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    shouldHide = _useState2[0],
    setShouldHide = _useState2[1];
  var elementRef = useRef(null);
  var startElementRef = useRef(null);
  var isInView = useInView(startElementRef);
  useEffect(function () {
    var element = elementRef.current;
    if (!element) {
      return undefined;
    }
    var observer = new IntersectionObserver(function (_ref) {
      var _entry$boundingClient;
      var _ref2 = _slicedToArray(_ref, 1),
        entry = _ref2[0];
      var isHide = (entry === null || entry === void 0 ? void 0 : entry.isIntersecting) || ((_entry$boundingClient = entry === null || entry === void 0 ? void 0 : entry.boundingClientRect.y) !== null && _entry$boundingClient !== void 0 ? _entry$boundingClient : 0) < 0;
      setShouldHide(isHide);
    });
    observer.observe(element);
    return function () {
      observer.unobserve(element);
    };
  }, []);
  return {
    elementRef: elementRef,
    shouldHide: shouldHide,
    startElementRef: startElementRef,
    isInView: isInView
  };
};